module.exports = __webpack_public_path__ + "static/media/ramen.c73affcc.jpg";